var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"version-title"},[_vm._v("\n  versión "+_vm._s(_vm.number)+" de "+_vm._s(_vm.month)+" de "+_vm._s(_vm.year)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }